import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { nebulaConst } from '@interfaces/nebulaConst';

/**
 * Setzt den Seitentitel aus dem `breadcrumbLabel` der tiefsten aktiven Route.
 * Hat die tiefste Route kein Label, bleibt der bisherige Titel stehen.
 * Die Router-Eigenschaft `title` wird bewusst nicht ausgewertet, da keine Route sie nutzt.
 */
@Injectable({
  providedIn: 'root'
})
export class BreadcrumbTitleStrategy extends TitleStrategy {
  private titleService = inject(Title);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    let route = snapshot.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const label = route.data?.['breadcrumbLabel'] as string | undefined;
    if (label) {
      this.titleService.setTitle(`${label} |  ${nebulaConst.appTitle}`);
    }
  }
}
